import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";
import { ApplicationStatusEnum } from "./job-application.dto";

export const CreateJobApplicationSchema = z.object({
  resumeId: z.string().cuid().optional(),
  companyName: z.string().min(1).max(200),
  jobTitle: z.string().min(1).max(200),
  jobDescription: z.string().optional(),
  jobUrl: z.string().url().optional().or(z.literal("")),
  status: ApplicationStatusEnum.optional(),
  appliedAt: z.string().datetime().optional(),
  generateCoverLetter: z.boolean().default(false),
  existingCoverLetterId: z.string().cuid().optional(),
  notes: z.string().optional(),
});

export class CreateJobApplicationDto extends createZodDto(CreateJobApplicationSchema) {}
